import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AcaoReuniao } from '../../../../../core/acao-reuniao';
import { ComboParticipanteReuniao } from '../../../../../core/combo-participante-reuniao';
import { ParticipanteReuniao } from '../../../../../core/participante-reuniao';
import { Reuniao } from '../../../../../core/reuniao';
import { DataUtilService } from '../../../../../services/commons/data-util.service';
import { ToastService } from '../../../../../services/toast/toast.service';

@Component({
  selector: 'cadastrar-acoes-reuniao',
  templateUrl: './cadastrar-acoes-reuniao.component.html',
  styleUrls: ['./cadastrar-acoes-reuniao.component.css']
})
export class CadastrarAcoesReuniaoComponent implements OnInit {

  @Input() reuniao: Reuniao;  
  @Output() onAbertoFormAdicaoAcaoReuniao = new EventEmitter();
  acaoReuniao: AcaoReuniao = new AcaoReuniao();
  participanteReuniao: ParticipanteReuniao = new ParticipanteReuniao();
  pinTiposAcoes = Date.now();

  tiposAcoes: any[] = [
    {tipo: 'Executar', flag: 'E'},
    {tipo: 'Decidir', flag: 'D'},
    {tipo: 'Informar', flag: 'I'}
  ];

  isAtualizar: Boolean = false;

  constructor(
    private dataUtilService: DataUtilService, private toastService: ToastService
  ) { }

  ngOnInit() {}


  iniciarObjetos() {
    this.acaoReuniao = new AcaoReuniao();
    this.participanteReuniao = new ParticipanteReuniao();
  }

  isAcaoJaAdicionada(): boolean {
    const acaoReuniaoAdicionada: AcaoReuniao = this.getAcaoDaLista();
    return !!acaoReuniaoAdicionada;
  }

  getAcaoDaLista() {
    return this.reuniao.acoesReuniao.find((acaoReuniao: AcaoReuniao) => 
      acaoReuniao.nomeResponsavel === this.participanteReuniao.nome && this.mesmasDatas(this.acaoReuniao.dataPrazo, acaoReuniao.dataPrazo)
      && acaoReuniao.descricaoAcao === this.acaoReuniao.descricaoAcao && acaoReuniao.situacaoTipoAcao === this.acaoReuniao.situacaoTipoAcao
    );
  }

  adicionar() {
    if (this.isAcaoJaAdicionada()) {
      this.toastService.showAlerta('Ação já adicionada para esta reunião');
      return;
    }
    const acaoReuniao = new AcaoReuniao();
    Object.assign(acaoReuniao, this.acaoReuniao);
    acaoReuniao.nomeResponsavel = this.participanteReuniao.nome;
    if (!this.reuniao.acoesReuniao) {
      this.reuniao.acoesReuniao = [];
    }

    this.reuniao.acoesReuniao.push(acaoReuniao);
    this.fecharFormAdicaoAcaoReuniao();
  }

  mesmasDatas(date1: Date, date2: Date): boolean {
    if (typeof date1 === 'string') {
      date1 = new Date(date1);
    }
    if (typeof date2 === 'string') {
        date2 = new Date(date2);
    }
    return date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate();
  }

  private fecharFormAdicaoAcaoReuniao() {
    this.onAbertoFormAdicaoAcaoReuniao.emit(false);
  }

  atualizar() {
    const acaoDaLista: AcaoReuniao = this.getAcaoDaLista();
    this.acaoReuniao.nomeResponsavel = this.participanteReuniao.nome;
    const index = this.reuniao.acoesReuniao.indexOf(acaoDaLista);
    this.reuniao.acoesReuniao.splice(index, 1, this.acaoReuniao);
    this.isAtualizar = false;
    this.iniciarObjetos();
  }

  atualizarAcao(acaoReuniao: AcaoReuniao) {
    this.participanteReuniao = this.getParticipanteReuniao(acaoReuniao.nomeResponsavel);
    this.isAtualizar = true;
    this.acaoReuniao = acaoReuniao;
  }

  cancelar() {
    this.iniciarObjetos();
    this.isAtualizar = false;
    this.fecharFormAdicaoAcaoReuniao();
  }

  onMascaraDataInput(event) {
    return this.dataUtilService.onMascaraDataInput(event);
  }

  onChangeNomeResponsavelAcaoReuniao(registro: ComboParticipanteReuniao) {
    Object.assign(this.participanteReuniao, registro);
    this.acaoReuniao.nomeResponsavel = this.participanteReuniao.nome;
  }

  getParticipanteReuniao(nomeResponsavel: string): ParticipanteReuniao {
    const participanteReuniaoEncontrado = this.reuniao.participantes.find((participanteReuniao: ParticipanteReuniao) => nomeResponsavel === participanteReuniao.nome);
    if (!participanteReuniaoEncontrado) {
      let participante = new ParticipanteReuniao();
      participante.id = Date.now() + Math.floor(Math.random() * 1000);
      participante.nome = nomeResponsavel;
      return participante;
    }
    return participanteReuniaoEncontrado;
  }
}
